var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutWork3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 92,
    viewBox: "0 0 90 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Develop/Design",
    clipPath: "url(#clip0_3_987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.0885 9.26711H26.872C25.9537 9.26711 25.4125 8.25035 25.9045 7.49597L29.5616 1.90377C30.4635 0.526218 32.4807 0.526218 33.3826 1.90377L37.0397 7.49597C37.5317 8.26675 36.9905 9.26711 36.0722 9.26711H36.0885Z",
    fill: "#236F5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.9778 22.8294V26.3716H39.5492C36.1545 26.3716 33.3994 29.1267 33.3994 32.5214V83.0644H17V22.8294L24.7569 11.0054H38.2209L45.9778 22.8294Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M71.5105 32.5212V54.7096H45.9766V26.355H65.3607C68.7554 26.355 71.5105 29.1101 71.5105 32.5048V32.5212Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M67.7559 58.7935H56.5224C53.9149 65.632 54.456 74.8321 54.456 74.8321C51.3729 69.3547 51.8814 62.3849 52.4553 58.7935H49.0114C49.0114 58.7935 45.3052 64.9104 46.3875 73.1921C47.4863 81.4903 56.6372 86.5085 58.3919 90.8707C60.1303 86.5085 69.2976 81.4903 70.3963 73.1921C71.4951 64.894 67.7723 58.7935 67.7723 58.7935H67.7559Z",
    stroke: "#161718",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 91,
    fill: "white",
    transform: "translate(0 0.870605)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutWork3);
export default __webpack_public_path__ + "static/media/aboutWork3.f74c55ad488ba2c5a41b69032ddb4925.svg";
export { ForwardRef as ReactComponent };